// Blocked-account gate page (L7). Same layout as AccessDenied/PendingActivation.
// Red on purpose: an admin deliberately blocked this login — a real rejection like
// /denied, not a waiting state (waiting stays yellow on /pending).
import { useMsal } from '@azure/msal-react'
import { Icon } from '../components/icons'
import { logout } from '../auth/authActions'
import { APP_NAME, APP_SUBTITLE } from '../config'
import { useSupportEmail } from '../lib/useSupportEmail'

export default function AccountBlocked() {
  const { accounts } = useMsal()
  const account = accounts[0]?.username
  const supportEmail = useSupportEmail()
  return (
    <div className="vitals" style={{ display: 'flex', flexDirection: 'column', minHeight: '100%', background: 'var(--cream)' }}>
      <header style={{ padding: '26px 40px', display: 'flex', alignItems: 'center', gap: 11 }}>
        <div className="vt-brand-mark"><Icon.spark size={17} /></div>
        <div>
          <div className="vt-brand-name" style={{ color: 'var(--woodland)' }}>{APP_NAME}</div>
          <div className="vt-brand-sub">{APP_SUBTITLE}</div>
        </div>
      </header>

      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 40px 80px' }}>
        <div style={{ maxWidth: 520, textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'var(--st-offline-soft)', border: '1px solid var(--st-offline-line)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 26, color: 'var(--st-offline)',
            boxShadow: 'var(--shadow-sm)' }}>
            <Icon.lock size={28} />
          </div>
          <h1 style={{ fontSize: 31, fontWeight: 600, letterSpacing: '-0.6px', color: 'var(--woodland)', lineHeight: 1.2 }}>
            Dein Zugang ist gesperrt
          </h1>
          <p style={{ fontSize: 16, color: 'var(--ink-70)', marginTop: 16, lineHeight: 1.6 }}>
            Dein Zugang wurde von einer Administratorin oder einem Administrator gesperrt. Wende dich an deine IT, wenn das ein Fehler ist.
          </p>

          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginTop: 26, padding: '10px 16px',
            background: 'var(--surface)', border: '1px solid var(--st-offline-line)', borderRadius: 24, boxShadow: 'var(--shadow-sm)' }}>
            <span className="vt-status offline" style={{ fontSize: 13.5 }}><span className="vt-dot"></span>Zugang gesperrt</span>
          </div>

          {account && (
            <div style={{ marginTop: 38, paddingTop: 26, borderTop: '1px solid var(--line-strong)' }}>
              <div className="vt-eyebrow" style={{ fontSize: 11.5 }}>Angemeldet als</div>
              <div className="vt-mono" style={{ fontSize: 13.5, color: 'var(--ink)', marginTop: 3, fontWeight: 500 }}>{account}</div>
            </div>
          )}

          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 30 }}>
            <button className="vt-btn vt-btn-primary" style={{ padding: '11px 20px' }} onClick={() => logout()}>
              <Icon.refresh size={15} />Mit anderem Konto anmelden
            </button>
          </div>

          <p style={{ fontSize: 13.5, color: 'var(--ink-50)', marginTop: 30 }}>
            Sollte das ein Fehler sein? <a href={`mailto:${supportEmail}`} style={{ color: 'var(--portugal)', fontWeight: 500, textDecoration: 'none' }}>IT kontaktieren</a>
          </p>
        </div>
      </main>
    </div>
  )
}
